import { Component, ElementRef, OnInit } from '@angular/core';
import { Log } from '@s8l/client-tree-lib';

import { AnalyticsMetric, StatsService } from 'src/app/services/stats.service';

import { AggregationGroup } from '../../../services/jsonrpc/stats-server.service';
import { HomeWidget } from '../dashboard-widget.utils';

@Component({
  selector: 'app-total-active-time',
  templateUrl: './total-active-time-widget.component.html',
  styleUrls: ['./total-active-time-widget.component.scss']
})
export class TotalActiveTimeWidgetComponent extends HomeWidget implements OnInit {
  public error = false;
  public value: string = null;

  constructor(elRef: ElementRef, private stats: StatsService) {
    super(elRef);
  }

  ngOnInit() {
    this.stats
      .fetchMetrics(
        AnalyticsMetric.time,
        this.settings.relative,
        [AggregationGroup.date],
        this.settings.filter,
        this.settings.exclude,
        this.settings.from,
        this.settings.to
      )
      .then(data => {
        const sum = data.reduce((prev, curr) => prev + curr.time, 0);
        this.value = this.stats.formatMetric(AnalyticsMetric.time, sum, this.settings.relative, '0:00:00');
        this.error = false;
      })
      .catch(err => {
        this.error = true;
        Log.log('TotalActiveTimeWidgetComponent', 'Error', err);
      });
  }
}
